export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11678.b9332937.jpg";